exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-container.conduct-charter,\r\n.app-container.conduct-charter main,\r\n.app-container.conduct-charter #main {\r\n    min-height: 0 !important;\r\n    margin-bottom: 0 !important;\r\n    padding-bottom: 0 !important;\n}\n.app-container.conduct-charter .view-container {\r\n    margin-bottom: 0 !important;\r\n    padding-bottom: 0 !important;\n}\n.app-container.conduct-charter .footer-component {\r\n    display: none !important;\n}\r\n", ""]);

// exports
